<template>
  <div>
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
import LayoutHorizontal from "@/layouts/LayoutHorizontal.vue";
import LayoutFull from "@/layouts/LayoutFull.vue";
import LayoutVertical from "@/layouts/LayoutVertical.vue";
import { computed } from 'vue'
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    LayoutFull,
    LayoutHorizontal,
    LayoutVertical,
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const { t } = useI18n()

    useHead({
      title: computed(() => {
        let title = ''
        if (route.meta.pageTitle) {
          title = t(route.meta.pageTitle)
        }
        if (title !== '') {
          title += ' - '
        }
        title += store.state.appName
        return title
      }),
    })
  },
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return "layout-vertical";
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";
</style>
